<div class="input-control" style="height: 40px;">
    <input type="text" placeholder="-- {{separator}} -- {{separator}} ---- " [(ngModel)]="_strDate"
        (keydown)="_onInputKeyDown($event)" (ngModelChange)="_onInputChange($event)" [disabled]="disabled">
    <span (click)="_onModalRequest()">
        <i *ngIf="_strDate == ''" class="feather-calendar"></i>
        <i *ngIf="_strDate != ''" class="feather-x-circle" (click)="clear()"></i>
    </span>
</div>